import { get } from 'lodash'

import { cms, tidyName } from '../../helper'
import { store } from '../../Redux/Config/configureStore'

export const getTabNameForLogs = (parentPageName, tabName) => {
  const cmsPage = store.getState().CMS.coreData?.page
  let page = cmsPage?.[parentPageName]
  let currentTab = page?.component_call_buttons?.find((tab) => tab?.name === tabName)
  if (currentTab) {
    return cms(currentTab?.cms_tab_key)
  } else {
    return tabName
  }
}

export const getFieldsAndLabelByTab = (parentPageName, tabName) => {
  const cmsPage = store.getState().CMS.coreData?.page
  let page = cmsPage?.[parentPageName]
  let currentTab = page?.component_call_buttons?.find((tab) => tab?.name === tabName)

  let fields = []
  currentTab?.component_call_form?.[0]?.component_call_fields?.map((field) => {
    fields?.push({
      field_id: field?.field_id,
      label: cms(field?.cms_key),
      type: field?.component_name,
    })
  })
  return fields
}

export const getValueByFieldTypeNid = (data, type, field_id) => {
  switch (type) {
    case 'toggle_switch':
      const v = get(data, field_id)
      if (v) {
        return <span class='badge badge-pill badge-success'>On</span>
      } else {
        return <span class='badge badge-pill badge-danger'>Off</span>
      }
    case 'select':
      if (field_id === 'role_id') return data?.role?.name
      return <div className='body2'>{get(data, `${field_id}_label`) || tidyName(get(data, `${field_id}`))}</div>
    case 'rich_text':
      return <div dangerouslySetInnerHTML={{ __html: get(data, `${field_id}`) }} className='body2'></div>
    case 'file_upload':
      if (!get(data, `${field_id}`)) return <div>No Image</div>
      return <img src={process.env.REACT_APP_STORAGE + get(data, `${field_id}`)} width={'110px'}></img>
    default:
      return <div className='body2'>{get(data, field_id)}</div>
  }
}

export const checkIsDataUpdated = (oldData, newData, field_id) => {
  if (get(oldData, field_id) != get(newData, field_id)) {
    return true
  }
  return false
}

export const checkIsFieldHide = (field_id) => {
  const fields = ['password', 'password_confirmation', 'merged_user']
  if (fields?.includes(field_id)) {
    return true
  }
  return false
}

/** CMS sometimes stores action in tab_name when type is missing (e.g. invalid enum locker_deletes). */
export const resolveLogType = (log) => {
  const type = log?.type
  if (type) return type
  const tab = log?.tab_name
  if (tab === 'locker_delete' || tab === 'planned_locker_delete') return 'locker_delete'
  return type || tab || 'update'
}

export const parseLogJson = (value, fallback = null) => {
  if (value == null || value === '') return fallback
  if (typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (e) {
    return fallback
  }
}

export const checkIsDataUpdatedInLog = (oldData, newData, fields) => {
  let isDataUpdated = false
  fields?.map((field) => {
    if (!checkIsFieldHide(field?.field_id)) {
      if (checkIsDataUpdated(oldData, newData, field?.field_id)) {
        isDataUpdated = true
      }
    }
  })
  return isDataUpdated
}
